// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608170721/js/" + chunkId + "." + {"44":"4dafcd90","225":"eebe42f6","481":"86cc8521","486":"85b2c776","770":"b87cd5cd"}[chunkId] + ".0.09577631395045638.chunk.js";
};